// Import app styles
import "./styles/main.scss";

// Add assets to /dist
import "./assets/favicon.ico";
import "./assets/small-logo-black.svg";
import "./assets/user.png";

// Add polyfills
import "core-js/es/promise";
import "core-js/es/array";
import "core-js/es/object/assign";

// Components CSS
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
